import { $, $$ } from 'utils/dom';

const popUp = $('[data-js=pop-up]');

if (popUp) {
  const controlPopUp = () => {
    if (localStorage.getItem('popup') !== 'false') {
      popUp.classList.add('is-active');
      const closeButton = $('.pop-up__close');
      closeButton.focus();
    }

    const closeButtons = $$('[data-js=pop-up-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        popUp.classList.remove('is-active');
        localStorage.setItem('popup', 'false');
      });
    });
  };

  window.addEventListener('load', () => {
    controlPopUp();
  });
}
